<template lang="pug">
form.flex.flex-col.smx-form-container(
  onsubmit="return false",
  :style="{ 'max-width': width ? width : '800px' }"
)
  .form-grid(
    :style="{ 'grid-template-columns': `${labelWidth ?? 'max-content'} minmax(0, ${width})` }"
  )
    slot
  .form-actions.flex.mt-8(v-if="hasSlot('actions')")
    slot(name="actions")
</template>

<script setup lang="ts">
import { useSlots } from "vue";

const props = withDefaults(
  defineProps<{
    // Width of the fields
    width?: string;
    // Width of the labels
    labelWidth?: string;
  }>(),
  {
    width: "600px",
  },
);

const slots = useSlots();
function hasSlot(name: string) {
  return !!slots[name];
}
</script>

<style>
.form-grid {
  display: grid;
  row-gap: 1.2rem;
  column-gap: 1rem;
}

.smx-form-container {
  max-width: max-content;
}

.form-grid > * {
  min-height: 31px;
}

/* NOTE: This is to adjust the height with input elements */
.form-grid > .label,
.form-grid > p,
.form-grid > a,
.form-grid > div,
.form-grid > span {
  padding-top: 5px;
}

.form-grid > div:has(input) {
  padding-top: 0;
}

.form-grid > .el-checkbox {
  padding-top: 0;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.form-grid > .label {
  justify-content: flex-end;
  align-items: start;
  display: flex;
  max-width: 250px;
}

@media only screen and (max-width: 768px) {
  .form-grid > .label {
    justify-content: flex-start;
  }
}

@media only screen and (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr !important;
    row-gap: 0.2rem;
  }

  .form-actions {
    flex-direction: column-reverse;
  }

  .form-actions > * + * {
    margin-bottom: 1rem;
    margin-left: 0 !important;
  }
}
</style>
